/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_Term_Services_DescInputs */

const en_terms_section_2_term_services_desc = /** @type {(inputs: Terms_Section_2_Term_Services_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI systems, automation, software development and consulting work Lindevo offers.`)
};

const lv_terms_section_2_term_services_desc = /** @type {(inputs: Terms_Section_2_Term_Services_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI sistēmas, automatizācija, programmatūras izstrāde un konsultācijas, ko piedāvā Lindevo.`)
};

/**
* | output |
* | --- |
* | "The AI systems, automation, software development and consulting work Lindevo offers." |
*
* @param {Terms_Section_2_Term_Services_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_term_services_desc = /** @type {((inputs?: Terms_Section_2_Term_Services_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_Term_Services_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_term_services_desc(inputs)
	return en_terms_section_2_term_services_desc(inputs)
});